module.exports = __webpack_public_path__ + "img/mobiles.b20110de.png";